(async () => {
  if (!customElements.get('images-row-slider')) {
    const { default: Swiper } = await import('swiper');
    const { Navigation, Pagination, Scrollbar, Autoplay } = await import('swiper/modules');

    const { Fancybox } = await import('@fancyapps/ui');

    class ImagesRowSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = this.querySelector('[data-images-row-slider]');

        // Stop when the swiper is not found
        if (!this.swiper) {
          return;
        }

        // Create elements
        this.mainSlider();
        this.fancybox();
      }

      /*
       * Create main slider
       */
      mainSlider() {
        // Default to improve user experience
        this.swiperOptions = {
          threshold: 10,
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        };

        // Check if we have extra options on the HTML
        if (this.swiper.dataset.options) {
          const options = JSON.parse(this.swiper.dataset.options);
          if (options) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...options,
            };
          }
        }

        // Call swiper with selected swiper element and options
        this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

        /**
         * Listen to extra events when in Shopify editor
         */
        if (Shopify.designMode) {
          // Update the swiper when the section event is triggerd
          window.addEventListener('shopify:section:load', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
          });

          // When on block select go to the slide in front-end
          window.addEventListener('shopify:block:select', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
            this.handleBlockSelect(event);
          });

          // When on block deselect go to the slide in front-end
          window.addEventListener('shopify:block:deselect', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
            this.handleBlockSelect(event);
          });
        }
      }

      /*
       * Create fancybox
       */
      fancybox() {
        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }
        Fancybox.bind('[data-fancybox]', {
          animated: false,
          showClass: false,
          mainClass: 'image-zoom',
        });
      }
    }

    window.ImagesRowSlider = ImagesRowSlider;

    customElements.define('images-row-slider', ImagesRowSlider);
  }
})();
